import lastModuleStorageKey from "~/pwa/lastModuleStorageKey";

const getLastModuleKey = (): string | null => {
	if (typeof localStorage === "undefined") return null;
	try {
		return localStorage.getItem(lastModuleStorageKey);
	} catch {
		return null;
	}
};

export default getLastModuleKey;
